<template>
  <div>

    <div>
      <div class="start-end">
        <span class="span-start">开启---------------</span>
        <ul id="v-for-object">
          <li v-for="value in startObject" @click="showCar(value)" style="margin-top: 20px; margin-left: 20px;">
            {{ value }}
          </li>
        </ul>
      </div>


      <div class="start-end">
        <span class="span-start">停止---------------</span>
        <ul id="v-for-object">
          <li v-for="value in stopObject" @click="showCar(value)" style="margin-top: 20px; margin-left: 20px;">
            {{ value }}
          </li>
        </ul>
      </div>
    </div>

  </div>

</template>

<script>
  import {
    getCarList
  } from '@/api/car'

  export default {
    name: 'radioList',
    components: {},
    data() {
      return {
        startObject: '',
        stopObject: '',
        dataCarListReq: {
          pageIndex: '2',
          pageSize: '10',
        },

      }

    },
    mounted() {
      this.setCarList();
    },
    methods: {
      showCar(value) {
        console.log(value) //控制台输出
      },
      setCarList() {

        getCarList(this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize).then(res => {

          this.startObject = res.data[1]
          this.stopObject = res.data[2]
        })
      }

    },


  }
</script>

<style>

  .start-end {
    margin-top: 20px;
    margin-left: 20px;
  }

.span-start {
    color: #cecece;
    font-size: 15px;

    position: relative;
    /* padding: 35px; */
  }
</style>
